module.exports = __webpack_public_path__ + "img/describe3.9a6c22d3.png";